import React from 'react';
import { Eye, CheckCircle, XCircle, Clock } from 'lucide-react';
import PermissionGuard from '../PermissionGuard';
import { VerificationEntry } from '../../types';

interface VerificationRowProps {
  entry: VerificationEntry;
  onViewDetails: (entry: VerificationEntry) => void;
  formatDate: (date: Date) => string;
}

const VerificationRow: React.FC<VerificationRowProps> = ({ entry, onViewDetails, formatDate }) => {
	const getStatusIcon = (status: string) => {
		switch (status) {
			case 'verified':
				return <CheckCircle className="w-3 h-3 mb-1 mx-auto text-green-600" />;
			case 'failed':
				return <XCircle className="w-3 h-3 mb-1 m-auto text-red-600" />;
			case 'pending':
				return <Clock className="w-3 h-3 mb-1 m-auto text-yellow-600" />;
			default:
				return <Clock className="w-5 h-5 text-gray-600" />;
		}
	};

	const getStatusBadge = (status: string) => {
		const base = 'px-1 py-1 rounded-full text-xs font-medium flex justify-center items-center';
		if (status === 'verified') return `${base} bg-green-100 text-green-800`;
		if (status === 'failed') return `${base} bg-red-100 text-red-800`;
		if (status === 'pending') return `${base} bg-yellow-100 text-yellow-800`;
		return `${base} bg-gray-100 text-gray-800`;
	};

	return (
		<tr className="hover:bg-gray-50">
			<td className="px-3 py-1">{entry.ghanaCardId}</td>
			<td className="px-3 py-1">
				{entry.firstName || 'N/A'} {entry.lastName || ''}
			</td>
			<td className="px-3 py-1 text-center">
				{getStatusIcon(entry.status)}{' '}
				<span className={getStatusBadge(entry.status)}>{entry.status}</span>
			</td>
			<td className="px-3 py-1">{formatDate(entry.timestamp)}</td>
			<td className="px-3 py-1">
				<PermissionGuard permission="submissions.read">
					<button
						onClick={() => onViewDetails(entry)}
						className="text-ghana-red hover:underline flex items-center gap-1"
					>
						<Eye className="w-4 h-4" /> View
					</button>
				</PermissionGuard>
			</td>
		</tr>
	);
};

export default VerificationRow;
